import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useUsersService } from '../../../../apis/users/useUsersService';
import { TInternalUserListApiResponse } from '../../../../apis/users/users.api.interfaces';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getInternalUsersListKey = 'get-internal-users-list';

export const useInternalUsersListHook = (
  params: TPaginationParams & { search?: string }
): UseQueryResult<TInternalUserListApiResponse, TQueryError> => {
  const { getInternalUsers } = useUsersService();

  return useQuery<TInternalUserListApiResponse, TQueryError>({
    queryKey: [getInternalUsersListKey, params],
    queryFn: () => getInternalUsers(params),
    enabled: true,
  });
};
